import {environment} from '../../../environments/environment';

export const ImageUrls = {
  LOGO: environment.imageBaseUrl + '/logo.svg',
  LOGO_WHITE: environment.imageBaseUrl + '/logo-white.svg',
  AVATAR: environment.imageBaseUrl + '/avatar.svg',
  AUTH: environment.imageBaseUrl + '/auth.png',
  MESSAGE: environment.imageBaseUrl + '/message.png',
  BELL: environment.imageBaseUrl + '/bell.svg',
  PDF: 'assets/icons/pdf.svg',

  ACCREDITATION: {
    BACKGROUND: environment.imageBaseUrl + '/accreditation/background-pattern.svg',
    DOCTORS: environment.imageBaseUrl + '/accreditation/doctors.svg',
    LEFT: environment.imageBaseUrl + '/accreditation/left-image.png',
    FILE_ICON: environment.imageBaseUrl + '/accreditation/icons/file.svg',
    FILE_UPLOAD_ICON: 'assets/icons/upload.svg',
    DOWNLOAD_ICON: environment.imageBaseUrl + '/accreditation/icons/download.svg',
    FILE_DOWNLOAD_ICON: environment.imageBaseUrl + '/accreditation/icons/file-download.svg'
  },

  AUTHENTICATION: {
    PASSWORD_ICON: environment.imageBaseUrl + '/icons/password.svg',
    USERNAME_ICON: environment.imageBaseUrl + '/icons/username.svg'
  }
};
